// extracted by mini-css-extract-plugin
export var sliderRange = "_p2-2";
export var sliderRoot = "_p2-0";
export var sliderThumb = "_p2-3";
export var sliderTrack = "_p2-1";